import { FC } from 'app/FunctionalComponent'
import React from 'react'

export const LaneAnalysis: FC = () => {
	return <></>
}
